import VoicesAllPosts from "../Components/Voices/Overview/VoicesAllPosts";

const VoicesPostsPage = () => {
  return <VoicesAllPosts />;
};

export default VoicesPostsPage;
